module.exports = __webpack_public_path__ + "img/logo_emiles_horizontal.1130fd52.svg";